import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "bg-h-primary-50 border py-2" }
const _hoisted_2 = { class: "container mx-auto" }
const _hoisted_3 = { class: "mt-[64px]" }
const _hoisted_4 = { class: "w-full container mx-auto flex justify-between" }
const _hoisted_5 = { class: "space-x-2" }
const _hoisted_6 = { class: "container mx-auto mt-8" }
const _hoisted_7 = { class: "grid grid-cols-12 items-center overflow-auto px-5 py-3 gap-5" }
const _hoisted_8 = { class: "col-span-12 md:col-span-2 text-xl font-bold" }
const _hoisted_9 = { class: "col-span-6 md:col-span-3" }
const _hoisted_10 = { class: "p-input-icon-right w-full" }
const _hoisted_11 = { class: "col-span-6 md:col-span-3" }
const _hoisted_12 = { class: "col-span-12 md:col-span-4 flex justify-end" }
const _hoisted_13 = { class: "flex justify-center gap-3" }
const _hoisted_14 = { class: "flex flex-row items-center space-x-4" }
const _hoisted_15 = { class: "" }
const _hoisted_16 = { class: "font-[800]" }
const _hoisted_17 = { class: "flex flex-row space-x-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_BreadcrumbComponent = _resolveComponent("BreadcrumbComponent")!
  const _component_Button = _resolveComponent("Button")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_TagMaterials = _resolveComponent("TagMaterials")!
  const _component_InfiniteScroll = _resolveComponent("InfiniteScroll")!
  const _component_ConfirmDialog = _resolveComponent("ConfirmDialog")!

  return (_openBlock(), _createElementBlock("main", null, [
    _createVNode(_component_Loader, {
      loader: _ctx.formLoader,
      label: "Carregando...",
      loaderType: "progress"
    }, null, 8, ["loader"]),
    (!_ctx.formLoader)
      ? (_openBlock(), _createElementBlock("form", {
          key: 0,
          onSubmit: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.saveMaterials()), ["prevent"]))
        }, [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_BreadcrumbComponent, {
                home: _ctx.home,
                items: _ctx.items
              }, null, 8, ["home", "items"])
            ])
          ]),
          _createElementVNode("section", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("h4", null, _toDisplayString(_ctx.$t("labels.generic", {
                pt: `Plano ${_ctx.getMaterialTypePT(_ctx.lessonPlan.name)}`,
                en: `Plan ${_ctx.lessonPlan.name}`,
              })), 1),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_Button, {
                  class: "btn-outline",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.confirmModal()))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
                  pt: `Cancelar`,
                  en: `Cancel`,
                })), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_component_Button, {
                  class: "btn-primary",
                  type: "submit"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t("labels.generic", {
                  pt: `Salvar`,
                  en: `Save`,
                })), 1)
                  ]),
                  _: 1
                })
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_6, [
            _createVNode(_component_InfiniteScroll, { onOnScroll: _ctx.scrollMaterials }, {
              header: _withCtx(() => [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.$t("labels.generic", {
                    pt: `Selecionar objetos`,
                    en: `Select objects`,
                  })), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("span", _hoisted_10, [
                      _createElementVNode("i", {
                        class: "pi pi-search text-h-primary-500 cursor-pointer",
                        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onSearch()))
                      }),
                      _createVNode(_component_InputText, {
                        modelValue: _ctx.searchWord,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.searchWord) = $event)),
                        placeholder: 
                      _ctx.$t('labels.generic', { pt: 'Pesquisar', en: 'Search' })
                    ,
                        class: "w-full",
                        onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(($event: any) => (_ctx.onSearch()), ["prevent"]), ["enter"]))
                      }, null, 8, ["modelValue", "placeholder"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_11, [
                    _createVNode(_component_Dropdown, {
                      modelValue: _ctx.selected,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.selected) = $event)),
                      options: _ctx.filters,
                      optionLabel: "name",
                      class: "w-full",
                      onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onFilter()))
                    }, null, 8, ["modelValue", "options"])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", {
                        class: _normalizeClass(
                      _ctx.selected.active !== 0 || _ctx.searchWord !== ''
                        ? 'text-gray-300'
                        : ''
                    )
                      }, _toDisplayString(_ctx.$t("labels.generic", {
                        pt: "Selecionar tudo",
                        en: "Select all",
                      })), 3),
                      _createVNode(_component_Checkbox, {
                        modelValue: _ctx.selectAll,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.selectAll) = $event)),
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectAllMaterials())),
                        binary: true,
                        disabled: _ctx.selected.active !== 0 || _ctx.searchWord !== ''
                      }, null, 8, ["modelValue", "disabled"])
                    ])
                  ])
                ])
              ]),
              content: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.materials, (item, i) => {
                  return (_openBlock(), _createElementBlock("div", {
                    id: "content",
                    key: i,
                    class: _normalizeClass(`h-24 border-2 border-gray-100 p-4 flex flex-row items-center justify-between`)
                  }, [
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_v_icon, {
                        name: _ctx.getIcon(item.file?.mimetype),
                        class: "text-h-primary-500",
                        scale: 1.5
                      }, null, 8, ["name", "scale"]),
                      _createElementVNode("div", _hoisted_15, [
                        _createElementVNode("p", _hoisted_16, _toDisplayString(item.name), 1),
                        _createElementVNode("div", _hoisted_17, [
                          _createElementVNode("p", null, _toDisplayString(_ctx.$t("labels.generic", {
                          pt: `Classificação: ${_ctx.getLearningGroupTypePT(
                            item.learningGroupType
                          )} |`,
                          en: `Classification: ${item.learningGroupType} |`,
                        })), 1),
                          _createVNode(_component_TagMaterials, { material: item }, null, 8, ["material"])
                        ])
                      ])
                    ]),
                    _createVNode(_component_Checkbox, {
                      modelValue: item.checkbox,
                      "onUpdate:modelValue": ($event: any) => ((item.checkbox) = $event),
                      inputId: item.name,
                      value: item.id,
                      binary: true,
                      onClick: ($event: any) => (_ctx.addMaterial(item))
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "inputId", "value", "onClick"])
                  ]))
                }), 128))
              ]),
              _: 1
            }, 8, ["onOnScroll"])
          ])
        ], 32))
      : _createCommentVNode("", true),
    _createVNode(_component_ConfirmDialog, { style: { width: '80vw', maxWidth: '700px' } })
  ]))
}